export interface UserPermission {
  id: number,
  companyProfileUuid: string,
  uuid: string,
  permissionId: number,
  gestiuneId: number,
  code: string,
  name: string,
  orderIndex: number,
}

export interface Permission {
  id: number,
  code: string,
  name: string,
  orderIndex: number,
}

export const initialPermissionsState = {
  loggedUserPermissions: [{ id: 0, companyProfileUuid: '', uuid: '', permissionId: 0, gestiuneId: 0, code: '', name: '', orderIndex: 0 }],
  userPermissions: [],
  permissions: [],
};

export interface IPermissionsState {
  loggedUserPermissions: UserPermission[],
  userPermissions: UserPermission[],
  permissions: Permission[],
}
